module.exports = __webpack_public_path__ + "static/img/b_1.4b76d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b_1.jpg
// module id = 250
// module chunks = 0 1 2 3 4 5 6 7 8 9